import * as actionTypes from './actionTypes'

import roleAxios from '../../axios/role'
import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'

export const fetchRoles = filterOptions => {
  return dispatch => {
    const params = {
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10,
      role_id: filterOptions ? filterOptions.role_id : null
    }
    dispatch(fetchRolesStart())
    roleAxios
      .get('', {
        params
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: +per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, options: '', index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchRolesSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchRolesFailed(error))
      })
  }
}

export const fetchRolesStart = () => {
  return {
    type: actionTypes.FETCH_ROLE_START
  }
}

export const fetchRolesSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_ROLE_SUCCESS,
    pagination,
    records
  }
}

export const fetchRolesFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ROLE_FAILED,
    errorMessage
  }
}

export const fetchRoleById = recordId => {
  return dispatch => {
    dispatch(fetchRolesStart())
    roleAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchRoleByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchRolesFailed(error))
      })
  }
}

export const fetchRoleByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_ROLE_BY_ID_SUCCESS,
    recordData
  }
}

export const fetchRoleAssignmentData = recordId => {
  return dispatch => {
    dispatch(fetchRoleAssignmentDataStart())
    roleAxios
      .get(`/${recordId}/assignment`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchRoleAssignmentDataSuccess(response.data))
        }
      })
      .catch(error => {
        dispatch(fetchRoleAssignmentDataFailed(error))
      })
  }
}

export const fetchRoleAssignmentDataStart = () => {
  return {
    type: actionTypes.FETCH_ROLE_ASSIGNMENT_DATA_START
  }
}
export const fetchRoleAssignmentDataSuccess = assignmentData => {
  return {
    type: actionTypes.FETCH_ROLE_ASSIGNMENT_DATA_SUCCESS,
    assignmentData
  }
}
export const fetchRoleAssignmentDataFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ROLE_ASSIGNMENT_DATA_FAILED,
    errorMessage
  }
}

export const clearSelectedRoleRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_ROLE_RECORD
  }
}

export const createRole = (recordData, page) => {
  return dispatch => {
    dispatch(createRoleStart())

    roleAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Roles Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createRoleSuccess())
          dispatch(fetchRoles(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Role field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createRoleFailed())
      })
  }
}

export const createRoleStart = () => {
  return {
    type: actionTypes.CREATE_ROLE_START
  }
}

export const createRoleSuccess = () => {
  return {
    type: actionTypes.CREATE_ROLE_SUCCESS
  }
}

export const createRoleFailed = () => {
  return {
    type: actionTypes.CREATE_ROLE_FAILED
  }
}

export const updateRole = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateRoleStart())
    roleAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Role Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateRoleSuccess())
        dispatch(fetchRoles(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Role field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateRoleFailed())
      })
  }
}

export const updateRoleStart = () => {
  return {
    type: actionTypes.UPDATE_ROLE_START
  }
}

export const updateRoleSuccess = () => {
  return {
    type: actionTypes.UPDATE_ROLE_SUCCESS
  }
}

export const updateRoleFailed = () => {
  return {
    type: actionTypes.UPDATE_ROLE_FAILED
  }
}

export const assignRole = (recordId, recordData) => {
  return dispatch => {
    dispatch(assignRoleStart())
    roleAxios
      .post(`/${recordId}/assignment`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Role Assigned',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(assignRoleSuccess())
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Role field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(assignRoleFailed())
      })
  }
}

export const assignRoleStart = () => {
  return {
    type: actionTypes.ASSIGN_ROLE_START
  }
}

export const assignRoleSuccess = () => {
  return {
    type: actionTypes.ASSIGN_ROLE_SUCCESS
  }
}

export const assignRoleFailed = () => {
  return {
    type: actionTypes.ASSIGN_ROLE_FAILED
  }
}

export const deleteRole = (recordId, page) => {
  return dispatch => {
    dispatch(deleteRoleStart())
    roleAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Role Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteRoleSuccess())
        dispatch(fetchRoles(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: error.response.data.message,
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteRoleFailed())
      })
  }
}

export const deleteRoleStart = () => {
  return {
    type: actionTypes.DELETE_ROLE_START
  }
}

export const deleteRoleSuccess = () => {
  return {
    type: actionTypes.DELETE_ROLE_SUCCESS
  }
}

export const deleteRoleFailed = () => {
  return {
    type: actionTypes.DELETE_ROLE_FAILED
  }
}
